import { Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { type SortDirection } from 'hooks/useSortableRows';

interface SortableThProps {
  label: string;
  sortKey: string;
  activeSortKey: string | null;
  direction: SortDirection;
  onSort: (key: string) => void;
  style?: React.CSSProperties;
}

// Plain <th> with a click-to-sort affordance — for the hand-rolled <table>
// views (HaulersMonitorView, DispatchPlanV2View, ManualExcavatorPanel) that
// don't use a grid library and so have no built-in column sorting.
export function SortableTh({
  label,
  sortKey,
  activeSortKey,
  direction,
  onSort,
  style,
}: SortableThProps): JSX.Element {
  const isActive = activeSortKey === sortKey;
  return (
    <th
      style={{ ...style, cursor: 'pointer', userSelect: 'none' }}
      onClick={() => {
        onSort(sortKey);
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
        {label}
        {isActive ? (
          direction === 'asc' ? (
            <ArrowUpwardIcon sx={{ fontSize: 12 }} />
          ) : (
            <ArrowDownwardIcon sx={{ fontSize: 12 }} />
          )
        ) : (
          <UnfoldMoreIcon sx={{ fontSize: 12, opacity: 0.4 }} />
        )}
      </Box>
    </th>
  );
}
